import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Pagination from "@mui/material/Pagination";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import Loader from "Loader";
import SearchAccSessionReq from "../../../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import { useNavigate } from "react-router-dom";
import SessionsApi from "../../../../../Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq3 from "../../../../../Classes/Models/Requests/SearchStringOrIntReq";
import DataTable from "examples/Tables/DataTable";
import SearchSingleSessions from "./SearchSingleSessions";
import { useContext } from "react";
import { UserContext } from "App";
const Index = ({ SetAccSession }) => {
  let CurrentUser = useContext(UserContext);
  let navigate = useNavigate();
  let initReq = new SearchAccSessionReq();
  initReq.noAppointmentOnly = true;
  const [SearchReq, setSearchReq] = useState(initReq);

  const TableColumns = [
    { Header: "Acc. Session ID", accessor: "Id", align: "left" },
    { Header: "Session", accessor: "Session", align: "left" },
    { Header: "Patient", accessor: "Patient", align: "left" },
    { Header: "Therapist", accessor: "Therapist", align: "left" },
    { Header: "Time", accessor: "Time", align: "left" },
    { Header: "Paid For", accessor: "PaidFor", align: "left" },
    { Header: "Exception", accessor: "Exception", align: "left" },
    { Header: "Admitted", accessor: "Admitted", align: "left" },
    { Header: "Details", accessor: "Edit", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const [ResponseData, setResponseData] = useState({});
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  const [IsLoaded, setIsLoaded] = useState(false);

  const GetOptions = (session) => {
    if (
      CurrentUser.userType != "Admin" &&
      CurrentUser.userType != "Therapist" &&
      CurrentUser.userType != "AccountingEmployee" &&
      CurrentUser.userType != "AppointmentEmployee"
    ) {
      Swal.fire({
        title: "Access Denied",
        text: "Visit your admin to request this permission.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (CurrentUser.userType === "Therapist") {
      navigate("/AccountingSessions/Details", {
        state: {
          SearchSession: session,
        },
      });
    } else {
      navigate("/AccountingSessions/Details", {
        state: {
          SearchSession: session,
        },
      });
    }
  };
  const MakeTableRow = (session, index) => {
    const isDisabled = CurrentUser.userType !== "Admin" && session.isAdmitted;
    return {
      Id: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          <button
            onClick={() => SetAccSession(session)}
            className={`btn btn-sm ${isDisabled ? "btn-secondary" : "btn-outline-success"}`}
            disabled={isDisabled}
          >
            <Icon>create</Icon>&nbsp;
            {session.id}
          </button>
        </MDTypography>
      ),

      Session: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.sessionName}
        </MDTypography>
      ),

      Time: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.appointmentTime}
        </MDTypography>
      ),

      Therapist: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.therapistName}
        </MDTypography>
      ),

      Patient: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.patientName}
        </MDTypography>
      ),
      Admitted: (
        <input
          id={"S.isAdmitted" + session.id}
          type="checkbox"
          disabled
          checked={session.isAdmitted ? "on" : ""}
        />
      ),
      Exception: (
        <input
          id={"S.isException" + session.id}
          type="checkbox"
          disabled
          checked={session.isException ? "on" : ""}
        />
      ),
      PaidFor: (
        <input
          id={"S.isPaidFor" + session.id}
          type="checkbox"
          disabled
          checked={session.isPaidFor ? "on" : ""}
        />
      ),
      Edit: (
        <MDTypography
          onClick={() => {
            GetOptions(session);
          }}
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          <Icon>more_vert</Icon>
        </MDTypography>
      ),
    };
  };

  const GetTableData = async () => {
    SearchReq.pagingParams.pageSize = 10;
    SearchReq.pagingParams.pageNumber = Page;
    console.log(SearchReq);
    var res = await SessionsApi.SearchAccountingSessions(SearchReq);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setResponseData(tempResponseData);
      setPaginationPages(res.data.totalPages);
      setIsLoaded(true);
    }
  };
  useEffect(() => {
    GetTableData();
  }, [Page]);
  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    //Get data
    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    } else {
      setTableDataRows([]);
    }
  }, [ResponseData]);

  if (!IsLoaded) {
    const loaderType = "balls";
    const loaderColor = "black";

    return <Loader type={loaderType} color={loaderColor} />;
  }
  return (
    <>
      <SearchSingleSessions
        IsLoaded={IsLoaded}
        setSearchReq={setSearchReq}
        GetTableData={GetTableData}
      />

      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          sx={{ backgroundColor: "#3560AD" }}
          variant="gradient"
          borderRadius="lg"
          coloredShadow="info"
          align="center"
        >
          <MDTypography variant="h6" color="white">
            Accounting Sessions Tables
          </MDTypography>
        </MDBox>
        <MDBox pt={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
          <div className="text-right mx-3 my-4">
            <Pagination
              count={PaginationPages}
              color="primary"
              onChange={(e, num) => setPage(num)}
              className="float-right"
            />
          </div>
        </MDBox>
      </Card>
    </>
  );
};

export default Index;
